import { ThunkAction } from 'redux-thunk';
import { NeoState } from '~/store/Reducers.interface';
import { INeoAction } from '~/store/Actions.interface';
import { dispatchSuccess } from '~/Helpers/Request.helper';
import { STATIC_ACTIONS } from '~/Constants/Actions.constants';
import { Tour } from '~/Models/interfaces/Tour.enum';
import { MutableRefObject } from 'react';

export const setProductTour = (
  payload: Tour,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.SET_PRODUCT_TOUR, payload, {});

export const setProductTourRef = (
  payload: MutableRefObject<null>,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.SET_PRODUCT_TOUR_REF, payload, {});

export const clearProductTour = (): ThunkAction<any, NeoState, unknown, INeoAction> => async (
  dispatch,
) => dispatchSuccess(dispatch, STATIC_ACTIONS.CLEAR_PRODUCT_TOURS, {}, {});
